import {combineReducers} from 'redux';
import ACTION from '../action_constant';
import cookie from '../util/cookie';

function storeSessionOnCookie(data){
  const cookieData = {
  userId : data.userId,
  token : data.token,
  name : data.name,
  email : data.email,
  profileImageUrl : data.profileImageUrl,
  isVerified : data.isVerified,
  phoneNumber : data.phoneNumber,
  countryCode : data.countryCode,
  phoneNumberWithoutCountryCode : data.phoneNumberWithoutCountryCode,
  isFacebookLogin : data.isFacebookLogin,
  sessionValid : data.sessionValid,
  userVerificationDocumentImageUrl : data.userVerificationDocumentImageUrl
  }
  cookie.set('_sd',JSON.stringify(cookieData),60*24*60*60); // store token for 60 days
}

function handleSignUp(state, action) {
    switch (action.status) {
        case 'progress':
            return {
                signup: {
                    inProgress: true,
                    emailSignup: action.type === ACTION.SIGNUP.EMAIL,
                    facebookSignup: action.type === ACTION.SIGNUP.FACEBOOK
                }
            }
        case 'success':
            return {userData: action.data}
        case 'error':
            return {
                signup: {
                    errorData: action.data
                }
            }
        default:
            return state;
    }
}

function handleSignIn(state, action) {
    switch (action.status) {
        case 'progress':
            return {
                signin: {
                    inProgress: true,
                    emailSignin: action.type === ACTION.SIGNIN.EMAIL,
                    facebookSignin: action.type === ACTION.SIGNIN.FACEBOOK
                }
            }
        case 'success':
            return {userData: action.data}
        case 'error':
            return {
                signin: {
                    errorData: action.data
                }
            }
        default:
            return state
    }
}

function getSessionData() {
    let sessionData;
    try {
        sessionData = {
            userData: JSON.parse(cookie.get('_sd'))
        };
    } catch (e) {
        sessionData = {};
    }
    return sessionData;
}

function auth(state = getSessionData(), action) {
    if (action.type === ACTION.SIGNUP.EMAIL || action.type === ACTION.SIGNUP.FACEBOOK) {
        return handleSignUp(state, action);
    } else if (action.type === ACTION.SIGNIN.EMAIL || action.type === ACTION.SIGNIN.FACEBOOK) {
        return handleSignIn(state, action);
    } else if (action.type === ACTION.STORESESSIONDATA) {
        return {userData: action.data}
    } else if (action.type === ACTION.CLEAR_AUTH_DATA) {
        return {}
    } else if(action.type === ACTION.UPDATE_AUTH){
      action.data.data.email = action.data.data.emailId;
      delete action.data.data["emailId"]
      let userData = Object.assign({},state.userData, action.data.data );
      storeSessionOnCookie(userData);
      return {userData : userData};
    } else if(action.type === ACTION.CLEAR_AUTH_DATA){
      return {}
    } else if(action.type === ACTION.SESSION_VALID){
        let userData = Object.assign({},state.userData, action.data );
        storeSessionOnCookie(userData);
        return {userData : userData};
    }else if (action.type === ACTION.VERIFICATION) {
      let verificationUrl = {
        userVerificationDocumentImageUrl : action.data.imageUrl,
        isVerified : true
      }
      let userData = Object.assign({},state.userData,verificationUrl);
      storeSessionOnCookie(userData);
      return {userData : userData};
    }else if (action.type === ACTION.EDIT_PROFILE_IMAGE) {
      let userData = Object.assign({},state.userData,action.data);
      storeSessionOnCookie(userData);
      return {userData : userData};
    }

    return state;
}

module.exports = auth;



// WEBPACK FOOTER //
// app/auth/auth_reducers.jsx